import {
  Button,
  Col,
  List,
  Modal,
  Row,
  Segmented,
  Space,
  Typography,
  message,
} from "antd";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import { ExclamationCircleFilled, FileWordOutlined } from "@ant-design/icons";

import { getFile, getSerieDetails } from "../../api/Get";
import { useEffect, useState } from "react";
import { postReleaseSerie } from "../../api/Post";
import EpisodeCard from "../episodes/EpisodeCard";
import { deleteEpisode } from "../../api/Delete";
import TextArea from "antd/es/input/TextArea";
import { putSaison } from "../../api/Put";
import { toDocx } from "../editor/exporter/toDocx";

const { Title } = Typography;
const { confirm } = Modal;

const serieDetailsLoader = async ({ params }) => {
  const details = await getSerieDetails(params.idSerie);
  return details;
};

const SerieDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { serie } = state;
  const { seasons } = useLoaderData();

  const [seasonIndex, setSeasonIndex] = useState(0);
  const [episodes, setEpisodes] = useState([]);
  const [sumupSaison, setSumupSaison] = useState(seasons[0].summary);

  const [isLoading, setIsLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const displayMsg = (
    success,
    msgSuccess = "Série publiée",
    msgFail = "La série n'a pas pu être publiée"
  ) => {
    messageApi.open({
      type: success ? "success" : "error",
      content: success ? msgSuccess : msgFail,
    });
  };

  useEffect(() => {
    setEpisodes(
      seasons[seasonIndex].Episodes.sort((a, b) => a.number - b.number)
    );
    setSumupSaison(seasons[seasonIndex].summary);
  }, [seasonIndex, seasons]);

  const onUpdateSumup = async () => {
    console.log(sumupSaison);
    setIsLoading(true);
    const res = await putSaison({
      idSaison: seasons[seasonIndex].id,
      sumup: sumupSaison,
    });
    displayMsg(
      res.error === undefined,
      "Résumé mis à jour",
      "Le résumé n'a pas été mis à jour suite à une erreur"
    );
    setIsLoading(false);
  };

  const onDeleteConfirm = async (idEp) => {
    if (idEp !== null) {
      await deleteEpisode(serie.id, idEp);
      window.location.reload(true);
    }
  };

  const showDeleteConfirm = (idEp) => {
    confirm({
      title: "Es-tu sûr de vouloir supprimer cet épisode ?",
      icon: <ExclamationCircleFilled />,
      content: "Son intégration ainsi que son fichier sera supprimé.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Non",
      onOk: () => {
        onDeleteConfirm(idEp);
      },
    });
  };

  const renderRow = (episode) => {
    return (
      <EpisodeCard
        serie={serie}
        seasonIndex={seasonIndex}
        episode={episode}
        onClickEdit={() => {
          if (episode.EpFile)
            navigate(`/doc/${episode.EpFile.uid}`, {
              state: { serie, episode },
            });
          else
            navigate(`/episode/${episode.id}/gpt`, {
              state: { serie, episode },
            });
        }}
        onClickSettings={() => {
          navigate(`/episode/${episode.id}`, {
            state: { serie, episode, seasons },
          });
        }}
        onClickDelete={(idEp) => {
          showDeleteConfirm(idEp);
        }}
      />
    );
  };

  const release = async () => {
    setIsLoading(true);
    const res = await postReleaseSerie(serie.id);
    console.log(res.status);
    if (res.status === 200) {
      displayMsg(true);
      setTimeout(() => {
        window.location.reload();
      }, [750]);
    } else {
      displayMsg(false);
      setIsLoading(false);
    }
  };

  const downloadAllDocx = async () => {
    for (let i = 0; i < episodes.length; i++) {
      const ep = episodes[i];
      if (ep.EpFile && ep.EpFile.uid) {
        const details = await getFile(ep.EpFile.uid);
        if (details.lines)
          toDocx(
            { lines: details.lines },
            `EP${ep.number} - ${ep.name}.docx`,
            i === 0 ? sumupSaison : null
          );
      }
    }
  };

  return (
    <>
      {contextHolder}
      <Title level={2}>{serie.name}</Title>
      <Space direction="horizontal">
        <Button
          disabled={isLoading}
          type="primary"
          onClick={() => {
            navigate(`/serie/${serie.id}`, {
              state: { serie, collectionName: serie.CollectionName },
            });
          }}
        >
          Mettre à jour la série
        </Button>
        <Button disabled={isLoading} onClick={release}>
          Publier la série
        </Button>
        <Button
          type="text"
          disabled={isLoading}
          onClick={() => {
            navigate(`/serie/add/saison`, {
              state: { serie, seasons },
            });
          }}
        >
          Ajouter une saison
        </Button>
        <Button
          type="text"
          disabled={isLoading}
          onClick={() => {
            navigate(`/serie/add/episode`, {
              state: { serie, seasons },
            });
          }}
        >
          Ajouter un épisode
        </Button>
      </Space>
      <br />
      <br />

      <Row>
        <Col span={24}>
          <Segmented
            block
            options={seasons
              .sort((s1, s2) => s1.number - s2.number)
              .map((sea, index) => {
                return { label: `Saison ${sea.number}`, value: index };
              })}
            value={seasonIndex}
            onChange={(v) => {
              console.log(v);
              setSeasonIndex(v);
            }}
          />
        </Col>
      </Row>
      <br />
      <br />
      <Row>
        <Col span={20}>
          <TextArea
            placeholder="Il était une fois Lulu à Brest qui allait à la plage faire du surf..."
            value={sumupSaison}
            onChange={(v) => {
              setSumupSaison(v.target.value);
            }}
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Col>
        <Col>
          <Button loading={isLoading} onClick={onUpdateSumup}>
            Mettre à jour
          </Button>
        </Col>
      </Row>
      <br />
      <br />
      <Button onClick={downloadAllDocx}>
        <FileWordOutlined />
      </Button>
      {/* <Button type="default">
        <DeleteOutlined />
      </Button> */}
      <br />
      <br />
      <List
        style={{ marginTop: 20 }}
        size="small"
        grid={{ column: 3 }}
        dataSource={episodes}
        renderItem={renderRow}
      />
    </>
  );
};

export { SerieDetails, serieDetailsLoader };
